import { IRecommendedPackagesState } from './types';

export const defaultState: IRecommendedPackagesState = {
  checkoutModalData: {
    packageId: 0,
    autoprolong: false,
    marketingPrice: 0,
    discountPercent: 0,
    price: 0,
    durationInDays: 0,
    totalAuctionPoints: 0,
    regions: [],
    category: '',
    startDate: '',
    endDate: '',
    services: [],
    polygonIds: [],
    gifts: [],
  },
  selectedPackageId: null,
  isFillBalance: false,
  packages: [],
};
